module.exports = __webpack_public_path__ + "static/media/tessellana_veyseli.e4056504.jpg";